<script setup>
import { useRoute } from 'vue-router'

const props = defineProps({
  attributes: Object,
  isEditable: Boolean
})
const { store_uuid, company_uuid } = useRoute().params
</script>

<template>
  <div class="tabelog">
    <div class="tabelog__item">
      <div class="tabelog__info">
        <p class="tabelog__name">{{ $t('pages.CompaniesLocationStore.tabelogAttributes.pr') }}</p>
        <div class="tabelog__content">
          <template v-if="props.attributes.pr && (props.attributes.pr.title || props.attributes.pr.context)">
            <h3>{{ props.attributes.pr.title }}</h3>
            <p>{{ props.attributes.pr.context }}</p>
          </template>
          <p v-else>{{ $t('messages.noSettings') }}</p>
        </div>
      </div>
    </div>
    <div v-if="props.isEditable" class="c-button c-button--right">
      <router-link
        :to="{ name: 'CompaniesLocationStoreTabelogEdit', params: { company_uuid: company_uuid, store_uuid: store_uuid } }"
        class="c-button__item c-button__item--primary"
      >
        {{ $t('labels.change') }}
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tabelog {
  &__item {
    padding: 0 32px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__info {
    padding: 24px 0;
  }
  &__name {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__content {
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-all;
  }
  .c-button {
    align-self: center;
    margin-top: 0;
    padding: 32px 0;
    &__item {
      margin: 0;
    }
  }

  &__attributeGroup {
    display: flex;
    margin: 24px 0;
    padding: 15px;
    &__groupDisplayName {
      font-weight: bold;
    }
    &__label {
      margin-bottom: 10px;
    }
    &__attributes {
      display: flex;
      align-items: center;
      line-height: 24px;
      margin: 16px 0;
      svg {
        margin-left: 5px;
      }
    }
    &__content {
      border: 1px solid #E3E3E3;
      padding: 15px;
    }
    &__block {
      width: 50%;
      &:first-child {
        margin-right: 15px;
      }
    }
  }
}
</style>
